
<template>
    <div class="users_filter">
        <b-modal
            :hide-header=true
            v-model="show_modal" v-bind:no-close-on-backdrop=true
            dialogClass="modal-dialog-left modal-lg" bodyClass="p-0" size="xl">

            <div id="panel_prod_list" class="panel mb-0 border-bottom-0 shadow-none">
                <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                    <h2>
                        <span class="fw-300">
                            {{ __t('SELECT_PRODUCT') }}
                        </span>
                    </h2>
                    <div class="panel-toolbar pr-3 pb-2 align-self-end">
                        <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed"
                                v-on:click="close()">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                </div>

                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="search_filed">
                            <b-input-group>
                                <b-input-group-text slot="prepend" :placeholder="__t('SEARCH_BY_NAME_CODE_ID')" >
                                    {{__t('FIND_PRODUCTS')}}
                                </b-input-group-text>
                                <b-form-input v-model="search"></b-form-input>
                            </b-input-group>
                        </div>

                        <b-overlay :show="is_load">
                            <div v-if="search_items.length > 0" class="mt-2">
                                <product_inside_list
                                    key="prod_list_in_search"
                                    @on_prod_select="on_prod_select"
                                    :active_ids="active_ids"
                                    @remove_product=""
                                    :show_remove="false"
                                    :show_select="true"
                                    :items="search_items">
                                </product_inside_list>
                            </div>
                        </b-overlay>
                    </div>
                </div>
            </div>

            <template slot="modal-footer" slot-scope="{ ok, cancel }">
                <b-button size="xl" variant="success" @click.prevent="close_filter()">
                    {{__t('PROCESS')}}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>

import Product_inside_list from "../inside_list/product_inside_list.vue";

export default {
    name: "product_search_list",
    components: {Product_inside_list},

    props: {
        exclude_ids: {
            type: Array,
            default: () => []
        },
        already_selected_ids: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            show_modal : true,
            is_load: false,
            search : "",
            search_items : [],
            pre_select_items : [],
        }
    },

    methods: {

        on_prod_select(prod_id) {
            const prodIndex = this.pre_select_items.findIndex(prod => parseInt(prod.id) === parseInt(prod_id));
            if (prodIndex !== -1) {
                this.pre_select_items.splice(prodIndex, 1);
            } else {
                const product = this.search_items.find(prod => parseInt(prod.id) === parseInt(prod_id));
                if (product) {
                    this.pre_select_items.push(product);
                }
            }
        },

        async load_products() {
            this.is_load = true;
            this.search_items = [];
            await api.post('/internal/v1/catalog/products',{
                "filter" : {
                    "search" : this.search
                },
                "list" : {
                    "limit" : 100,
                }
            })
            .then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.search_items = [];
                    data.data
                        .filter(item => !this.exclude_ids.includes(parseInt(item.id)))
                        .map(item => {
                            item.is_selected = false;
                            this.search_items.push(item);
                        });
                }
            })
            .catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },

        close() {
            this.$emit('close_product_search');
        },

        close_filter() {
            this.$emit('finish_select',this.pre_select_items);
            this.$emit('close_product_search');
        },
    },

    computed: {
        dialog_class_draw() {
            if (this.modal_position === "left") {
                return "modal-dialog-left modal-sm";
            }

            return "modal-dialog-left modal-xl";
        },

        active_ids() {
            return this.pre_select_items.map(item => {
                return item.id;
            });
        },
    },

    watch: {
        'search': function () {
            if (this.search.length > 2) {
                this.load_products();
            } else {
                this.search_items = [];
            }
        },
    }
}
</script>


<style scoped>

</style>
